import { useState, useEffect, useRef } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  DialogContent,
  Typography,
  Grid,
  DialogActions,
  Button,
  Container,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { LoadingError, LoadingPaper } from "../../LoadingComponents";
import { prettify } from "../../../utils/utils";
import { EditableInputDisplay, useEditMode } from "../../EditableComponents";
import {
  useGetThresholds,
  thresholdsSkeleton,
  useUpdateThresholds,
} from "../useServiceQueries";

function ViewSoglie({ service_id, closeModal, _editMode }) {
  // === web service queries/mutations ===
  const serviceQuery = useGetThresholds(service_id);
  const updateSoglieMutation = useUpdateThresholds(service_id, closeModal);

  // === EditMode handling ===
  const {
    editMode,
    enterEditMode,
    cancelEditMode,
    confirmEditMode,
    updateEditState,
    setQueryKey,
  } = useEditMode({
    editModeEnabled: _editMode,
    updateMutation: updateSoglieMutation,
    specificUpdateKey: "threashold",
  });
  setQueryKey(["services", service_id]);

  useEffect(() => {
    if (editMode) enterEditMode();
  }, []);

  return (
    <>
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={closeModal}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <DialogContent>
        {serviceQuery.isLoading ? (
          <LoadingPaper />
        ) : serviceQuery.isError ? (
          <LoadingError error={serviceQuery.error} />
        ) : (
          <>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h5" component="div">
              Soglie del servizio:{" "}
              <strong>{prettify(serviceQuery.data.service)}</strong>
            </Typography>

            <Grid item container sx={{ marginTop: "10px" }}>
              {Object.keys(serviceQuery.data.threashold).map((t) => {
                return (
                  <Grid item xs={6} key={t}>
                    <Container sx={{ marginTop: "5px", marginBottom: "5px" }}>
                      <EditableInputDisplay
                        id={t}
                        label={thresholdsSkeleton[t]}
                        initialValue={serviceQuery.data.threashold[t]}
                        setEditMode={editMode}
                        inputMode={
                          t === "email_alert" ||
                          t === "sms_alert" ||
                          t === "cr_alert"
                            ? "bool"
                            : "numeric"
                        }
                        setParentValue={updateEditState}
                      />
                    </Container>
                  </Grid>
                );
              })}
            </Grid>
          </>
        )}
      </DialogContent>
      {editMode ? (
        <DialogActions>
          <Button
            disabled={updateSoglieMutation.isLoading}
            onClick={confirmEditMode}
          >
            Conferma
          </Button>
          <Button
            disabled={updateSoglieMutation.isLoading}
            color="error"
            onClick={cancelEditMode}
          >
            Annulla
          </Button>
          <Button
            disabled={updateSoglieMutation.isLoading}
            color="error"
            onClick={closeModal}
          >
            Chiudi
          </Button>
        </DialogActions>
      ) : (
        <DialogActions>
          <Button
            disabled={updateSoglieMutation.isLoading}
            onClick={enterEditMode}
          >
            Modifica
          </Button>
          <Button
            disabled={updateSoglieMutation.isLoading}
            color="error"
            onClick={closeModal}
          >
            Chiudi
          </Button>
        </DialogActions>
      )}
    </>
  );
}

export default ViewSoglie;
